<template>
  <div class="body">
    <div class="inv-h-w">
      <div :class="['inv-h',Inv==1?'inv-h-se':'']" @click="Inv=1">基本信息</div>
      <!-- <div :class="['inv-h',Inv==2?'inv-h-se':'']" @click="Inv=2">其他</div> -->
      <!-- <div :class="['inv-h',Inv==3?'inv-h-se':'']" @click="Inv=3">其他</div> -->
      <!-- <div :class="['inv-h',Inv==4?'inv-h-se':'']" @click="Inv=4">其他</div> -->
    </div>

    <div class="bodyInv" v-show="Inv == 1">
      <div class="addStaff">
        <el-form ref="form" :model="form" class="form" label-width="100px">
          <el-form-item label="姓名:">
            <el-input v-model="form.name" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-select :disabled="disabled" class="sexInput" v-model="form.sex + ''" placeholder="请选择性别">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系方式:">
            <el-input :disabled="disabled" v-model="form.telNumber"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码:">
            <el-input :disabled="disabled" v-model="form.idCard"></el-input>
          </el-form-item>
          <el-form-item label="底薪:">
            <el-input :disabled="disabled" v-model="form.basicSalary"></el-input>
          </el-form-item>
          <el-form-item label="邮箱:">
            <el-input :disabled="disabled" v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item label="员工提成比:">
            <el-input v-model="form.staffBonusRatio" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="所属部门:">
            <el-input :disabled="true" v-model="form.departmentName"></el-input>
          </el-form-item>
          <el-form-item label="编辑部门:" :style="{'display':display}">
            <el-cascader :disabled="disabled" class="selectInput" v-if="form.prentId" :options="departLists"
                         @change="departSend" v-model="form.prentIds"
                         :props="{ multiple: false, checkStrictly: true ,value:'id',label:'name',children:'sub'}"
                         clearable></el-cascader>
          </el-form-item>

          <el-form-item label="网页权限">
            <el-checkbox v-for="(item,index) in form.web" :disabled="disabled" v-model="item.possess" :key="index"
                         :label="index" name="type">{{ item.name }}
            </el-checkbox>
            <!-- <el-checkbox-group v-model="form.webs"  @change="webChange">
            <el-checkbox v-for="(item,index) in web" :key="index" :label="index"  name="type">{{item.name}}</el-checkbox>
            </el-checkbox-group> -->
          </el-form-item>
          <el-form-item label="APP权限">
            <el-checkbox v-for="(item,index) in form.cms" :disabled="disabled" v-model="item.possess" :key="index"
                         :label="index" name="type">{{ item.name }}
            </el-checkbox>
            <!-- <el-checkbox-group v-model="form.cmss" @change="appChange">
            <el-checkbox v-for="(item,index) in cms" :key="index" :label="index" name="type">{{item.name}}</el-checkbox>
            </el-checkbox-group> -->
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="send" @click="onSubmit">{{ bottonTitle }}</el-button>
          </el-form-item>
        </el-form>

      </div>
    </div>
    <div class="bodyInv" v-show="Inv == 2">
      3123212323132131
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      form: {
        name: null,
        sex: null,
        telNumber: null,
        idCard: null,
        email: null,
        basicSalary: null,
        departmentId: null,
        prentIds: null,
        cms: null,
        web: null,
      },
      Inv: 1,
      disabled: true,
      display: 'none',
      demo: [],
      bottonTitle: '编辑',
      departLists: [],
    }
  },
  created() {
    //监听游览器后退事件
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.staffBack, false)
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.staffBack, false)
  },
  mounted() {
    this.departList()
    this.staffInfo()
  },
  methods: {
    staffBack(){
       this.$router.replace({path:'staff'})
    },
    //员工详情
    staffInfo() {
      console.log(this.$route.query)
      this.joker.staff.staffInfo(this.$route.query.id).then(res => {
        console.log(res)
        this.form = res.content
      })
    },

    onSubmit() {
      if (this.disabled) {
        this.disabled = false
        this.bottonTitle = '保存'
        this.display = 'block'
      } else {
        console.log(this.form)
        this.joker.staff.staffUpdate(this.form).then(res => {
          console.log(res)
          alert("修改成功")
          this.disabled = true
          this.bottonTitle = '编辑'
          this.display = 'none'
        })
      }
    },
    //部门列表
    departList() {
      this.joker.department.departList().then(res => {
        console.log(res)
        this.departLists = res.content
      })
    },

    //选择部门
    departSend(e) {
      console.log(e)
      if (e.length == 0) {
        this.form.web = null
        this.form.cms = null
      } else {
        var id = e.pop()
        this.form.departmentId = id
        this.joker.staff.deptList(id).then(res => {
          console.log(res)
          this.form.web = res.content.web
          this.form.cms = res.content.cms
        })
      }


    },

  }
}
</script>


<style scoped>
.inv-h-w {
  background-color: #FFFFFF;
  display: flex;
  margin-top: 1%;
  width: 96%;
  border-radius: 10px;
  margin-left: 2%;
  margin-bottom: 1%;
  height: 40px;
  font-size: 18px;
}

.inv-h {

  /* flex: 1; */
  text-align: center;
  color: #6d6f78;
  line-height: 40px;
  display: inline-block;
  width: 15%;
}

.inv-h-se {
  border-radius: 10px;
  color: #FFFFFF;
  background-color: #5BA7FF;
  border-bottom: 4 upx solid #5BA7FF;
}

.bodyInv {
  background-color: #FFFFFF;
  width: 96%;
  margin-left: 2%;
  border-radius: 10px;
}

/* .addStaff{
    width: 50%;
    margin-left: 1%;
    margin-top: 1%;
    border-radius: 10px;
} */
.form {
  width: 40%;
  margin-left: 30%;
  padding-top: 5%;
  padding-bottom: 5%;
}

.sexInput {
  width: 100%;
}

.selectInput {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Staff/staffInfo.vue